export const emptyFunction = () => {};
export const validationMessages = ["Esse campo é necessario", "Campo Invalido"];
